export default __webpack_public_path__ + "static/media/x-icon.29481fa7.svg";